import { FinishNewsletterPopupProps } from '@husky-x/cc-finish-newsletter-popup/dist/types/models';

export const FinishProductDifferencesMock = {
  header: '<h2>ДІЗНАЙТЕСЯ ПРО ВІДМІННОСТІ МІЖ ПРОДУКТАМИ FINISH</h2>',
  borderedImage: true,
  navigationButton: {
    link: '/produkty/',
    label: 'ПЕРЕГЛЯНУТИ ВСІ ПРОДУКТИ',
  },
  useCheckmark: false,
  tables: [
    {
      title: 'FINISH',
      legend:
        '<ul>\n<li><sup>*</sup>очищення затверділих плям при повному завантаженні посудомийної машини.</li>\n<li><sup>**</sup>порівняно з Finish Power на основі середньої ваги.</li>\n<li><sup>***</sup>ефективно видаляє пригорілі залишки їжі.</li>\n<li><sup>****</sup>інгредієнт: ензим</li>\n</ul>',
      rows: [
        {
          text: 'Глибоке очищення',
          image:
            'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/blt82888abe65a3cf92/66a8bd75f24439cde173be08/clean.svg',
        },
        {
          text: 'Сяючий блиск',
          image:
            'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/blt4068f74db0e98470/66a8bdf6b8115e2482a37a72/shine.svg',
        },
        {
          text: 'Проти затверділих протягом 48 годин залишків їжі<sup>*</sup>',
          image:
            'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/blt4b1a83960fae2f42/66a8bd75b8115e47cca37a6d/dried-on.svg',
        },
        {
          text: 'Ефективність проти жиру',
          image:
            'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/bltef4110afe98d3440/66a8bdf6f24439951073be0f/tough-on-grease.svg',
        },
        {
          text: 'Не потребує ополіскування',
          image:
            'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/bltb35fc648c6362147/66a8bdf61097ec6bcaa86bf5/skip-the-rinse.svg',
        },
        {
          text: 'Не потребує розпакування',
          image:
            'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/blt906d9e1af7cf7cf8/66a8bd7575e8676dacd73cd9/wrapper-free-tabs.svg',
        },
        {
          text: 'Швидке розчинення',
          image:
            'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/blt84a3d1465f181c87/66a8bdf67da9b43d0cb481c0/fast-dissolving.svg',
        },
        {
          text: 'Формула містить менше хімічних речовин<sup>**</sup>',
          image:
            'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/blt0b422bd29369e3e4/66a8bdf6739577514719fa1a/less-chemical-weight.svg',
        },
        {
          text: 'Захист скла',
          image:
            'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/blta20864530554004a/66a8bd751a892d24844a3ac8/glass-protection.svg',
        },
        {
          text: 'Свіжий аромат',
          image:
            'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/blt95a23ce6c566f108/66a8bd7517cd4f0b596f724a/freshness-boost.svg',
        },
        {
          text: 'Усуває пригорілі залишки їжі<sup>***</sup>',
          image:
            'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/bltf4e3970c7de0d7ea/66a8bd7506435dc50cddea0b/burnt-on-stains.svg',
        },
        {
          text: 'Поступове вивільнення інгредієнтів<sup>****</sup>',
          image:
            'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/blt4228905f1347b8d8/66a8bd75f095557978747345/right-ingredient-right-time-1.png',
        },
      ],
      columns: [
        {
          productImage:
            'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/blt5a1d9e23a9f38b42/66a8bab8f2443983a573bdfc/ultimate-plus-x2.png',
          productName: 'ULTIMATE PLUS',
          productLink: '/produkty/zasoby-dlia-myttia-posudu/finish-ultimate-plus-fresh-45/',
          color: 'gold-gradient',
          values: [
            {
              value: 5,
            },
            {
              value: 4,
            },
            {
              value: 4,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
          ],
        },
        {
          productImage:
            'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/blt885b71b3dca45c5a/66a8bd76b3baaf4f6397e363/ultimate-x2.png',
          productName: 'ULTIMATE',
          productLink: '/produkty/zasoby-dlia-myttia-posudu/finish-ultimate-fresh-50/',
          color: 'black-gradient',
          values: [
            {
              value: 4,
            },
            {
              value: 4,
            },
            {
              value: 3,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
          ],
        },
        {
          productImage:
            'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/blt9a8d029b63113ce2/66a8bd75fb2f0f64f438eba8/quantum-x2.png',
          productName: 'QUANTUM',
          productLink: '/produkty/zasoby-dlia-myttia-posudu/finish-quantum-fresh-60/',
          color: 'dark-blue-gradient',
          values: [
            {
              value: 3,
            },
            {
              value: 3,
            },
            {
              value: 2,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
          ],
        },
        {
          productImage:
            'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/bltf7e1f373bd749614/66a8bd753d47313511294ec4/power-x2.png',
          productName: 'POWER',
          productLink: '/produkty/zasoby-dlia-myttia-posudu/finish-power-all-in-one-fresh-48/',
          color: 'blue-gradient',
          values: [
            {
              value: 2,
            },
            {
              value: 2,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
          ],
        },
      ],
    },
  ],
};

export const FinishProductCardsMock = {
  cards: [
    {
      productName: 'FINISH ULTIMATE',
      image:
        'https://eu-images.contentstack.com/v3/assets/blt4dde3b0988d0aae1/bltc0707b2de1506ab1/67852267f1109c70a6c83f27/3279023.webp',
      cardStyle: 'dark-blue',
      button: {
        link: '/produkty/zasoby-dlia-myttia-posudu/finish-ultimate-fresh-50/',
        text: 'Більше про ULTIMATE',
      },
      icons: [
        {
          src: 'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/bltd1cced5b87a8da99/66a8e0aafd20b8f52f02207b/tough-on-grease-outline-red.webp',
          name: 'Ефективний проти жиру',
        },
        {
          src: 'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/blt17bfd79ff6231d4b/66a8e0a9fdec72853b5fee05/dried-on-stains-outline-red.webp',
          name: 'Проти затверділих протягом <strong>48</strong> годин залишків їжі',
          styleType: 'text-on-image',
        },
      ],
      mobileOrder: 2,
    },
    {
      productName: 'FINISH ULTIMATE PLUS',
      primary: true,
      image:
        'https://eu-images.contentstack.com/v3/assets/blt4dde3b0988d0aae1/blt69dfdfee88ce14f6/67852238e3dd24b206443e77/3283912_(1).webp',
      cardStyle: 'black',
      button: {
        link: '/produkty/zasoby-dlia-myttia-posudu/finish-ultimate-plus-fresh-45/',
        text: 'Більше про наш найкращий ULTIMATE PLUS',
      },
      icons: [
        {
          src: 'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/blt7d089cf277e6d47b/66a8e0a96ea8c533e9c94d69/extra-cleaning-power-outline-gold.webp',
          name: '<strong>3x</strong> більш інтенсивна формула',
          styleType: 'text-on-image',
        },
        {
          src: 'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/blt5ee59c8130b9cd59/66a8e0aa7da9b4508ab48253/tough-on-grease-gold-outline-gold.webp',
          name: 'Ефективний проти жиру',
        },
        {
          src: 'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/blt383c425593ccd620/66a8e0aa7da9b4e8dfb48257/burnt-on-stains-outline-gold.webp',
          name: 'Ефективний проти пригорілих залишків їжі',
        },
      ],
      mobileOrder: 1,
    },
    {
      productName: 'FINISH QUANTUM',
      image:
        'https://eu-images.contentstack.com/v3/assets/blt4dde3b0988d0aae1/blt9a58160c3a1066e6/679776875329892d79dae1bc/3283910.webp',
      cardStyle: 'light-blue',
      button: {
        link: '/produkty/zasoby-dlia-myttia-posudu/finish-quantum-fresh-60/',
        text: 'Більше про QUANTUM',
      },
      icons: [
        {
          src: 'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/bltd1cced5b87a8da99/66a8e0aafd20b8f52f02207b/tough-on-grease-outline-red.webp',
          name: 'Ефективний проти жиру',
        },
      ],
      mobileOrder: 3,
    },
  ],
};

export const FinishNewsletterPopupMock: FinishNewsletterPopupProps = {
  headline: 'NICHTS MEHR VERPASSEN',
  description:
    'Melden Sie sich über das folgende Formular für den Finish Newsletter an und bleiben Sie immer auf dem neuesten Stand rund um Finish! Mit betätigen des ANMELDEN-Buttons willigen Sie ein, von RB Hygiene Home Deutschland GmbH Informationen zu aktuellen Angeboten, Aktionen und anderen Neuigkeiten zur Finish Marke per E-Mail zu erhalten.',
  image: {
    src: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt7512496341f5a468/66f53c689441d6ee01fe1a7d/newsletter_popup_image.png',
    mobileSrc:
      'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt63c4941b86e10813/66f53c833097ebb254ddd0d8/newsletter_popup_image_mobile.png',
    alt: 'finish',
  },
  thankYou: {
    headline: 'VIELEN DANK FÜR IHRE ANMELDUNG FÜR DEN FINISH NEWSLETTER!',
    description: '',
    closeButton: {
      label: 'schließen',
      redirectUrl: '/',
    },
  },
  form: {
    id: '7f4311c4-00e3-48f9-a9cb-13b20ef2b28f',
    url: 'https://phx-promoplatform-api-pl-prod.promoplatform.rbcloud.io/api/v1/external/forms',
    submitErrorMessage: 'Bitte füllen Sie die erforderlichen Felder aus.',
  },
};
